export default "__VITE_ASSET__DQQHodfW__"